// export const URL = "http://localhost:8000/"
// export const THIS_URL = "http://localhost:3000/"

export const URL = "https://hubiback.enterscience.com.br/"
export const THIS_URL = "https://hubi.enterscience.com.br/"
